import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-12b352ac"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "task-time-estimate-input" }
const _hoisted_2 = { class: "task-time-estimate-input_buttons" }

import {
  TirPmDatepicker,
  DatepickerTypeEnum,
  TirPmButton,
  TirPmButtonSizeEnum,
  TirPmButtonVariantEnum,
} from 'tir-components';
import { onBeforeMount, PropType, ref, watch } from 'vue';
import { AdapterService } from './adapter-service';
import { PerformerEstimatedModel } from '../../models';

/**Api сервис */

export default /*#__PURE__*/_defineComponent({
  __name: 'task-time-estimate-input',
  props: {
  /**Оценка времени */
  estimate: { type: Number },
  /**Id задачи */
  taskId: { type: Number },
  /**Заблокировать */
  isDisabled: { type: Boolean, default: false },
  /**Может ли текущий пользователь выставлять итоговую оценку времени */
  canUpsertFinalEstimate: { type: Boolean },
  /**Оценка по исполнителю */
  performerEstimate: { type: Object as PropType<PerformerEstimatedModel> },
},
  emits: ["upsert", "cancel"],
  setup(__props, { emit }) {

const props = __props;

const apiService = new AdapterService();

/**Параметры */

/**События */


/**Выбранное время в формате Date */
const date = ref(new Date());
/**Сохранение времени */
const isLoading = ref(false);
/**Оценка на создание */
const editEstimate = ref(0);

/**Отслеживание изменений оценки */
watch(() => props.estimate, setEstimate, { immediate: true });

/**Перед рендером */
onBeforeMount(() => setDate());

function setEstimate() {
  editEstimate.value = props.estimate || 0;
}
/**Инициализация даты */
function setDate() {
  const { hours, minutes } = getHoursAndMinutes(editEstimate.value || 0);

  const newDate = new Date();
  newDate.setHours(Number(hours));
  newDate.setMinutes(Number(minutes));
  newDate.setSeconds(0);
  newDate.setMilliseconds(0);

  date.value = newDate;
}
/**Обновление выбранного времени */
const onTimeUpdate = (date: Date) => {
  const hours = date.getHours();
  const minutes = date.getMinutes();
  editEstimate.value = hours + minutes * 0.01;
};
/**Получение часов и минут */
const getHoursAndMinutes = (decimalTime: number) => {
  const [hoursStr, minutesStr = '00'] = decimalTime.toString().split('.');

  const hours = parseInt(hoursStr, 10);
  const minutes = parseInt(minutesStr.padEnd(2, '0').slice(0, 2), 10);

  const formattedHours = String(hours).padStart(2, '0');
  const formattedMinutes = String(minutes).padStart(2, '0');

  return { hours: `${formattedHours}`, minutes: `${formattedMinutes}` };
};

/**Сохранить оценку */
const saveEstimate = async () => {
  if (!editEstimate.value) return;

  isLoading.value = true;
  const query = props.canUpsertFinalEstimate
    ? apiService.upsertFinalEstimate
    : apiService.upsertEstimate;

  const response = await query.bind(apiService)(
    props.taskId,
    editEstimate.value,
    props.performerEstimate?.Id,
  );
  if (response.IsSuccess) {
    emit('upsert', editEstimate.value);
    editEstimate.value = 0;
    props.performerEstimate.IsEdit = false;
  }
  isLoading.value = false;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(TirPmDatepicker), {
      modelValue: date.value,
      "onUpdate:modelValue": [
        _cache[0] || (_cache[0] = ($event: any) => ((date).value = $event)),
        onTimeUpdate
      ],
      type: _unref(DatepickerTypeEnum).Time,
      isDisabled: __props.isDisabled,
      input: { isSmall: true, label: 'Время' }
    }, null, 8, ["modelValue", "type", "isDisabled"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(TirPmButton), {
        size: _unref(TirPmButtonSizeEnum).Small,
        variant: _unref(TirPmButtonVariantEnum).SecondaryState,
        "is-loading": isLoading.value,
        "is-disabled": !editEstimate.value,
        onClick: saveEstimate
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Сохранить ")
        ]),
        _: 1
      }, 8, ["size", "variant", "is-loading", "is-disabled"]),
      _createVNode(_unref(TirPmButton), {
        size: _unref(TirPmButtonSizeEnum).Small,
        variant: _unref(TirPmButtonVariantEnum).LinkState,
        onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('cancel')))
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Отмена ")
        ]),
        _: 1
      }, 8, ["size", "variant"])
    ])
  ]))
}
}

})